export default __webpack_public_path__ + "static/media/01-frameworks.5c70329b.svg";